import React from 'react';

const FaceHappy = ({ className = "" }) => (
  
    <svg className={className} width="200" height="120" viewBox="0 0 200 120" fill="none">
      {/* Source box */}
      <rect x="20" y="30" width="60" height="0" rx="0" stroke="currentColor" strokeWidth="0" fill="none"/>
      <line x1="35" y1="45" x2="65" y2="45" stroke="currentColor" strokeWidth="2"/>
      <line x1="35" y1="55" x2="65" y2="55" stroke="currentColor" strokeWidth="2"/>
      <line x1="35" y1="65" x2="55" y2="65" stroke="currentColor" strokeWidth="2"/>
      
      {/* Arrow */}
      <line x1="0" y1="55" x2="110" y2="55" stroke="currentColor" strokeWidth="0" strokeLinecap="round"/>
      <path d="M107 50 L115 55 L107 60" stroke="currentColor" strokeWidth="0" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      
      {/* Target box */}
      <rect x="125" y="0" width="60" height="50" rx="4" stroke="currentColor" strokeWidth="0" fill="none" strokeDasharray="5,5"/>
    </svg>

);

export default FaceHappy;